import React, { useState, useEffect, memo } from 'react';
import styled from 'styled-components';
import ListCardFooterGlobal from './ListCardFooterGlobal';
import {
  TertiaryColor,
  boxShadow, maxWidth,
  // maxWidth1170, 
  maxWidth1300, primaryActiveColor, primaryColor, primaryFont, primaryHeadingColor,
  retina,
  secondaryFont, wLight, wMBold, wMedium
} from 'constants/utilsStyles';
import ListCardPhotoAlbum from './ListCardPhotoAlbum';
import { Checkbox, Tooltip, Typography } from 'antd';
import classNames from 'classnames';
// import DropShadowListView from 'assets/svgs/DropShadowListView';
import { IListItem } from 'modules/Audience/interface';
import { useHistory } from 'react-router';
import { onOpenListLoadingUpdate } from 'modules/Audience/Actions/listDetailsActions';
import { getQueryParam } from 'utils';

const { Paragraph } = Typography;

const ListCardWrapper = styled.div`
  position: relative;
  border-radius: 13px;
  box-shadow: ${boxShadow};
  height: auto;
  margin: 0px 6px;
  &:hover {
    cursor: pointer;
  }
  &.tileView {
    width: 100%;
    margin: 0px;
    &.activeTile {
      outline: 2px solid ${primaryColor}; 
      outline-offset: -2px;
      background: ${primaryActiveColor};
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 5px 14px 24px;
    margin-top: 0px;
    @media all and (max-width: ${maxWidth1300}) {
      padding: 10px 5px 10px 5px;
    }
    .checkbox-div {
      margin-right: 20px;
      @media all and (max-width: ${maxWidth1300}) {
        margin-right: 10px;
      }
    }
    .inner-content {
      display: flex;
      flex-direction: row;
      width: calc(100% - 108px);
      padding: 0px 13px 0px;
      .textual-area {
        display: flex;
        flex-direction: column;
        width: calc(100% - 155px);
        height: unset;
        .list-card-title {
          margin-bottom: 14px;
        }
        .user-activities-list-div {
          display: flex;
          align-items: center;
          flex-direction: row;
          .link-text {
            display: block;
            font-family: ${primaryFont};
            font-weight: ${wMedium};
            font-size: 12px;
            line-height: 14px;
            color: ${primaryColor};
            &.gray {
              color: ${TertiaryColor};
            }
            &.ant-typography {
              margin-bottom: 0;
            }
          }
          .activity-text-wrapper {
            line-height: 12px;
          }
        }
      }
      .list-card-footer-global {
        margin-top: 0px;
        width: 145px;
        margin-left: 10px;
      }
    }
  }
  &.activeCard {
    outline: 2px solid ${primaryColor}; 
    outline-offset: -2px;
    .list-card-photo-album {
      .digestTileImage {
        .digest-image {
          &:first-child {
            border-left: 2px solid ${primaryColor};
          }
          &:nth-child(3) {
            border-right: 2px solid ${primaryColor};
          }
        }
      }
    }
    .inner-content {
      background: ${primaryActiveColor};
      border-bottom-left-radius: 13px;
      border-bottom-right-radius: 13px;
    }
  }
  .fixed-header {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 13px 15px 0;
  }
  .inner-content {
    padding: 14px 19px 10px;
    /* @media all and (max-width: ${maxWidth}), ${retina} {
      padding: 10px 10px;
    } */
    .textual-area {
      min-height: 72px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        min-height: 60px;
      }
      .list-card-title {
        font-family: ${secondaryFont};
        font-weight: ${wMBold};
        font-size: 24px;
        line-height: 28px;
        color: ${primaryHeadingColor};
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 20px;
          line-height: 24px;
          margin-bottom: 3px;
        }
      }
      .link-text {
        display: none;
      }
    }
    .list-card-footer-global {
      margin-top: 5px;
    }
  }
`;

type ActivityTextType = {
  listView: boolean,
  activityName: string,
  person: string | null,
  date: string | null,
}

const ActivityTextWrapper = styled.p`
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 0px;
  color: #67696A;
  display: flex;
  .performed-by {
    color:${primaryColor};
    font-weight: ${wLight};
    margin-left: 5px;
    &.ant-typography {
      margin-bottom: 0;
    }
  }
`;

export const ActivityTextDiv = function ActivityTextDiv(props: ActivityTextType) {
  const { activityName, person, date, listView } = props;
  const text = `${person} on ${date}`;
  return (
    <ActivityTextWrapper className={classNames('activity-text-wrapper text-truncate', { leftSeparator: listView })}>
      {activityName}
      {
        (person && date) ?
          <Paragraph className='performed-by' ellipsis={{ rows: 1, tooltip: text }}>
            {text}
          </Paragraph>
          : null
      }
    </ActivityTextWrapper>
  );
};

type Props = {
  listView?: boolean,
  list: IListItem,
  // formatString?: (str: string) => { name: string, date: string },
  selectedCount: number;
  handleSelection: (payload: number) => void;
  actionHandler: (listId: number) => void;
  disableSelect?: boolean;
  isSearched: boolean;
  listDetailListId: number;
} & typeof defaultProps;

const defaultProps = {
  listView: false,
  disableSelect: false,
};

const ListCardGlobal = function ListCardGlobal(props: Props) {
  const history = useHistory();
  const { listView, list, selectedCount, handleSelection, actionHandler, disableSelect, isSearched, listDetailListId } = props;
  const {
    listName,
    createdBy,
    lastUsedBy,
    listId,
    topContactsThumbnails,
    lastUpdated,
    topContactsPersonIds,
    totalContacts,
    campaignsCount,
    // formatString,
  } = list;
  const [active, setActive] = useState(false);
  // const { name, date } = formatString(createdBy);

  const campaignCountsText = `${campaignsCount} ${campaignsCount === 0 || campaignsCount === 1 ? 'link' : 'links'}`;

  const formatString = (str: string) => {
    if (str?.length > 0) {
      const [name, date] = str?.toString().split('on');
      return { name: name?.trim(), date: date?.trim() };
    };
  };

  // To unselect all the selected lists on clear selection.
  useEffect(() => {
    if (selectedCount === 0) {
      setActive(false);
    };
  }, [selectedCount]);

  const handleRedirection = () => {
    const isListsView = window.location.pathname.includes('lists');
    history.push(`/audiences/view/?list_id=${listId}${isListsView ? '&see_all=true' : ''}`);
    listDetailListId !== listId && onOpenListLoadingUpdate(true);
  };

  return (
    <ListCardWrapper
      className={classNames('list-card-global',
        { activeCard: active && !listView },
        { tileView: listView },
        { activeTile: active && listView }
      )}
      onClick={handleRedirection}
    >
      {listView ? (
        <div className='checkbox-div' onClick={(e) => e.stopPropagation()}>
          <Checkbox checked={active} disabled={disableSelect} onChange={() => { setActive(!active); handleSelection(listId); }} />
        </div>
      ) : (
        <div className='fixed-header' onClick={(e) => e.stopPropagation()}>
          {/* <DropShadowListView /> */}
          <Checkbox checked={active} disabled={disableSelect} onChange={() => { setActive(!active); handleSelection(listId); }} />
        </div>
      )}
      <ListCardPhotoAlbum
        listView={listView}
        totalContacts={totalContacts}
        topContactsThumbnails={topContactsThumbnails}
        topContactsPersonIds={topContactsPersonIds}
      />
      <div className='inner-content'>
        <div className='textual-area'>
          <Paragraph className='list-card-title text-truncate' ellipsis={{ rows: 1, tooltip: listName }}>{listName}</Paragraph>
          <div className='user-activities-list-div'>
            <Paragraph className='link-text' ellipsis={{ rows: 1, tooltip: campaignCountsText }}>{campaignCountsText}</Paragraph>
            <Paragraph className='link-text gray left-separator' ellipsis={{ rows: 1, tooltip: lastUpdated }}>{lastUpdated}</Paragraph>
            <ActivityTextDiv listView={listView} activityName='Created by:' person={createdBy !== "" ? `${formatString(createdBy?.toString())?.name}` : null} date={createdBy !== "" ? `${formatString(createdBy?.toString())?.date}` : null} />
            {lastUsedBy !== "" && <ActivityTextDiv listView={listView} activityName='Last Used by:' person={`${formatString(lastUsedBy?.toString())?.name}`} date={`${formatString(lastUsedBy?.toString())?.date}`} />}
          </div>
        </div>
        <ListCardFooterGlobal list={{ ...list }} actionHandler={actionHandler} isSearched={isSearched} />
      </div>
    </ListCardWrapper>
  );
};
export default memo(ListCardGlobal);